
import moment from 'moment'
const state = {
  selectedMeal: '', // 餐次
  currentClass: {}
}

// getters
const getters = {}

// actions
const actions = {
  saveCurrClass ({ commit }, data) {
    commit('saveCurrClass', data)
  },
  saveSelectedMeal ({ commit }, data) {
    if (!data) {
      const currentTime = moment().unix()
      const t = moment().hour(2).minute(0).seconds(0).unix()
      if (currentTime >= t && currentTime < t + 28800) { // 早餐
        data = 'breakfast'
      } else if (currentTime >= t + 28800 && currentTime < t + 46800) { // 午餐 10 ~ 15
        data = 'lunch'
      } else { // 晚餐
        data = 'dinner'
      }
    }
    commit('saveSelectedMeal', data)
  },
  nutritionStorage ({ commit }) {
    commit('nutritionStorage')
  },
  nutritionRestore ({ commit }) {
    const item = sessionStorage.getItem('currentClass')
    if (item) {
      commit('saveCurrClass', JSON.parse(item))
      sessionStorage.removeItem('currentClass')
    }
    const meal = sessionStorage.getItem('selectedMeal')
    if (meal) {
      commit('saveSelectedMeal', meal)
      sessionStorage.removeItem('selectedMeal')
    }
  }
}

// mutations
const mutations = {
  saveCurrClass (state, data) {
    state.currentClass = data || {}
  },
  saveSelectedMeal (state, data) {
    state.selectedMeal = data
  },
  nutritionStorage (state) {
    sessionStorage.setItem('currentClass', JSON.stringify(state.currentClass))
    sessionStorage.setItem('selectedMeal', state.selectedMeal)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
